import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "sticker-pack-descr" }
const _hoisted_3 = { class: "stickers" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

import {computed} from 'vue';
import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import {EMOJI_LIST} from "~/chat/vue/widget/tabs/chat/EmojiList";
import {ConfigStore} from "~/chat/ts/store/Config";
import {WidgetStickerInterface} from "~/chat/ts/data/ISiteParams";


const __default__ = {
    name: "EmojiSelector"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["select", "sticker"],
  setup(__props, { emit: __emit }) {

let emits = __emit;

let list = computed(() => {
    return EMOJI_LIST;
});

let stickerPacks = ConfigStore.siteParams.value.params.stickerPacks;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(stickerPacks) && _unref(stickerPacks).length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(stickerPacks), (pack) => {
          return (_openBlock(), _createElementBlock("div", {
            key: pack.id,
            class: "sticker-pack"
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(pack.descr), 1),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pack.stickers, (sticker) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: sticker.id,
                  class: "sticker",
                  style: _normalizeStyle({
                            backgroundImage: `url(${sticker.url}) !important`
                        }),
                  onClick: ($event: any) => (_unref(emits)('sticker', sticker))
                }, null, 12, _hoisted_4))
              }), 128))
            ])
          ]))
        }), 128))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (emoji, textValue) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "item",
        key: textValue,
        onClick: _withModifiers(($event: any) => (_unref(emits)('select', `:${textValue}:`)), ["stop"]),
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(Htmlify, {
          emoji: "",
          value: emoji
        }, null, 8, ["value"])
      ], 40, _hoisted_5))
    }), 128))
  ]))
}
}

})